export default class VprHowto {
  constructor (data) {
    this.title = data?.name ?? ''
    this.iframeUrl = data?.iframe_url ?? ''
  }

  get basePlayerUrl () {
    return this.iframeUrl.substring(0, this.iframeUrl.indexOf('index.xhtml'))
  }

  get sourcesPlayerUrl () {
    return this.basePlayerUrl ? `${this.basePlayerUrl}sources/` : ''
  }
}
